/* Pure selection rules, shared by the storefront and the regression checks. */
(function (root) {
  const api = {
    variant(variants, options) {
      return variants.find(v => v.options.length === options.length && v.options.every((value, i) => value === options[i])) || null;
    },
    fitment(rules, vehicle, variant) {
      if (!vehicle || !variant) return [];
      return rules.filter(r => r.vehicle === vehicle && (!r.variants.length || r.variants.some(id => String(id) === String(variant.id))));
    },
    safeDestination(path, origin) {
      try { const url = new URL(path, origin); return url.origin === origin && /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?(?:collections|products|search)(?:\/|$)/.test(url.pathname) ? url.href : null; } catch { return null; }
    }
  };
  if (typeof module !== 'undefined') module.exports = api;
  else root.MSTCommerce = api;
})(globalThis);
